import { AxiosInstance } from 'axios'

export const getRoles = (axios): Promise<any> => {
  return axios.get('/v1/roles')
}

export const setNotificationSettings = (
  axios: AxiosInstance,
  message: string,
  openWindow: string,
  deviceType: string[],
  roles: number[],
  url: string
): Promise<any> => {
  const payload = {
    message: message,
    open_window: openWindow,
    device_type: deviceType,
    roles: roles,
  }
  if (url) payload['url'] = url
  return axios({
    url: '/v1/push/send',
    method: 'post',
    data: payload,
  })
}
